import { useQuery } from '@tanstack/react-query'

import { AstraCallout } from '~/astra'
import { dispatchDefaultToast, dispatchSuccessToast } from '~/store/slices/toasterSlice'
import { HOSPITAL_CONFIG_LOCATION_INCLUDE, useLocation } from '~/storm'

import { dispatchFirstError } from '../../Form/formErrors'
import { FormSkeleton } from '../../Form/FormSkeleton'
import { FormPageWrapper } from '../../Form/FormWrapper'
import { useResourceNavigation } from '../../useResourceNavigation'
import { locationProfileQueries } from '../locationProfileQueries'
import { locationToFormState } from './formState'
import { LocationForm, type OnSubmitFunction } from './LocationForm'
import { saveEditLocation } from './saveLocation'

export const EditLocation = () => {
    const { entityId: locationId, navigateToList } = useResourceNavigation()

    const { isLoading, isSuccess } = useQuery(locationProfileQueries.importByLocationId(locationId ?? undefined))

    const location = useLocation({ where: { id: locationId ?? -1 }, include: HOSPITAL_CONFIG_LOCATION_INCLUDE })

    const handleSubmit: OnSubmitFunction = async (values, initialValues) => {
        if (!location) return
        const results = await saveEditLocation(values, initialValues, location)
        const error = dispatchFirstError(results)
        if (error) return
        if (results.length > 0) {
            dispatchSuccessToast('Stuen er oppdatert')
        } else {
            dispatchDefaultToast('Ingen endringer er gjort')
        }
        await navigateToList()
    }

    return (
        <FormPageWrapper backCrumb={{ title: 'Stuer', onClick: () => void navigateToList() }}>
            {isLoading ? (
                <FormSkeleton title="Rediger stue" />
            ) : location && isSuccess ? (
                <LocationForm title="Rediger stue" initialValues={locationToFormState(location)} onSubmit={handleSubmit} />
            ) : (
                <AstraCallout
                    text="Fant ikke spesifisert stue."
                    color="critical"
                    action={{ label: 'Tilbake til liste', onClick: () => void navigateToList() }}
                />
            )}
        </FormPageWrapper>
    )
}
